/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: OmegaRedZA (https://sketchfab.com/OmegaRedZA)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/game-ready-animated-mailbox-postbox-582c0ce1ffee41179ab981146ae0ff87
Title: Game Ready Animated Mailbox / Postbox
*/

import React, { useRef, useEffect } from "react";

import { useGLTF, useAnimations } from "@react-three/drei";
import { LoopOnce } from "three";
import useHoverGlow from "../../hooks/useHoverGlow";
import { useResponsiveValues } from "../../utils/responsiveValues";
import { config } from "../../config";

function Mailbox(props) {
  const group = useRef();
  // const [mailboxHovered, setMailboxHovered] = useState(false);
  // useCursor(mailboxHovered);

  const { mailbox } = useResponsiveValues();
  const { nodes, materials, animations } = useGLTF("/models/mailbox2.glb");
  const { actions } = useAnimations(animations, group);

  const { setHovered } = useHoverGlow(materials, "#7FFF00", 5);

  // Refs para controlar estado sin re-renderizar
  const isOpen = useRef(false);

  useEffect(() => {
    const action = actions["Take 001"];
    if (action) {
      action.clampWhenFinished = true; // se queda en el último frame
      action.loop = LoopOnce; // solo una vez
      action.paused = true; // empieza pausada
    }
  }, [actions]);

  const handleClick = (e) => {
    e.stopPropagation();
    const action = actions["Take 001"];
    if (!action) return;

    action.paused = false;

    if (!isOpen.current) {
      // 🔹 ABRIR (normal)
      // window.open(
      //  `mailto:${config.contact.email}?subject=Inquiry%20about%20your%203D%20development%20services&body=Hello%20[Your%20Name],%0A%0AI%20came%20across%20your%20portfolio%20and%20I'm%20interested%20in%20learning%20more%20about%20the%203D%20development%20services%20you%20offer.%0A%0ACould%20you%20please%20share%20more%20details%20about%20your%20expertise%20and%20availability%3F%0A%0AThank%20you%20for%20your%20time!%0A%0ABest%20regards,%0A[Sender%20Name]`
      // );
      action.reset();
      action.timeScale = 1;
      action.play();

      // 🔸 Detener al final
      setTimeout(() => {
        action.paused = true;
        action.time = action.getClip().duration; // se asegura de quedar al final
        isOpen.current = true;
      }, 2500); // ⏱ dura 2.5 segundos
    } else {
      // 🔹 CERRAR (reversa)
      action.timeScale = -1; // animación inversa
      action.paused = false;
      action.play();

      // 🔸 Detener al principio
      setTimeout(() => {
        action.paused = true;
        action.time = 0;
        isOpen.current = false;
      }, 2500);
    }
  };

  return (
    <group
      ref={group}
      {...props}
      dispose={null}
      scale={mailbox.scale}
      position={mailbox.position}
      rotation={mailbox.rotation}
      onClick={handleClick}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
    >
      <group name="Scene">
        <group
          name="Sketchfab_model"
          rotation={[-Math.PI / 2, 0, 0]}
          scale={0.007}
        >
          <group
            name="f1dcef4834e941108620015430dd0775fbx"
            rotation={[Math.PI / 2, 0, 0]}
          >
            <group name="Object_2">
              <group name="RootNode">
                <group
                  name="Dummy001"
                  position={[5.171, 141.468, -34.816]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={2.54}
                >
                  <group
                    name="Box001"
                    position={[-3.349, -29.203, 0]}
                    scale={1.01}
                  >
                    <mesh
                      name="Box001_01_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Box001_01_-_Default_0"].geometry}
                      material={materials["01_-_Default"]}
                    />
                  </group>
                  <group
                    name="Box002"
                    position={[-2.728, -1.764, 0]}
                    rotation={[-0.002, 0, -Math.PI]}
                  >
                    <mesh
                      name="Box002_01_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Box002_01_-_Default_0"].geometry}
                      material={materials["01_-_Default"]}
                    />
                  </group>
                  <group
                    name="Cylinder001"
                    position={[6.625, -10.738, 9.669]}
                    rotation={[1.716, 1.558, 2.996]}
                    scale={0.866}
                  >
                    <mesh
                      name="Cylinder001_01_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder001_01_-_Default_0"].geometry}
                      material={materials["01_-_Default"]}
                    />
                    <mesh
                      name="Cylinder001_02_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder001_02_-_Default_0"].geometry}
                      material={materials["02_-_Default"]}
                    />
                    <mesh
                      name="Cylinder001_03_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder001_03_-_Default_0"].geometry}
                      material={materials["03_-_Default"]}
                    />
                    <mesh
                      name="Cylinder001_07_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder001_07_-_Default_0"].geometry}
                      material={materials["07_-_Default"]}
                    />
                  </group>
                  <group
                    name="Cylinder002"
                    position={[5.562, -2.224, 0.643]}
                    rotation={[Math.PI, -1.565, Math.PI]}
                  >
                    <mesh
                      name="Cylinder002_09_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder002_09_-_Default_0"].geometry}
                      material={materials["09_-_Default"]}
                    />
                  </group>
                  <group
                    name="Cylinder003"
                    position={[-10.172, -2.224, 0.643]}
                    rotation={[Math.PI, -1.565, Math.PI]}
                  >
                    <mesh
                      name="Cylinder003_09_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Cylinder003_09_-_Default_0"].geometry}
                      material={materials["09_-_Default"]}
                    />
                  </group>
                  <group
                    name="Cylinder004"
                    position={[-2.545, -15.255, -55.696]}
                    scale={[1, 1, 1.51]}
                  />
                  <group
                    name="Tube001"
                    position={[-3.073, -1.659, 9.633]}
                    rotation={[1.573, 0, 0]}
                  >
                    <group name="Box003" position={[-3.113, -8.892, 12.45]}>
                      <group
                        name="Object_17"
                        rotation={[-1.573, -0.716, 0]}
                        scale={[1, 0.98, 0.98]}
                      >
                        <mesh
                          name="Box003_13_-_Default_0"
                          castShadow
                          receiveShadow
                          geometry={nodes["Box003_13_-_Default_0"].geometry}
                          material={materials["13_-_Default"]}
                        />
                      </group>
                    </group>
                    <group name="Box004" position={[7.971, -8.888, 13.868]}>
                      <group
                        name="Object_14"
                        rotation={[-1.573, -1.553, 0]}
                        scale={[1, 0.98, 0.98]}
                      >
                        <mesh
                          name="Box004_14_-_Default_0"
                          castShadow
                          receiveShadow
                          geometry={nodes["Box004_14_-_Default_0"].geometry}
                          material={materials["14_-_Default"]}
                        />
                      </group>
                    </group>
                    <group name="Box005" position={[7.421, -8.268, 13.867]}>
                      <group
                        name="Object_20"
                        rotation={[-0.134, -1.431, 1.441]}
                        scale={[1, 0.98, 0.98]}
                      >
                        <mesh
                          name="Box005_14_-_Default_0"
                          castShadow
                          receiveShadow
                          geometry={nodes["Box005_14_-_Default_0"].geometry}
                          material={materials["14_-_Default"]}
                        />
                      </group>
                    </group>
                    <group name="Box006" position={[1.945, -8.111, 12.448]}>
                      <group
                        name="Object_11"
                        rotation={[-1.478, 0.711, 2.996]}
                        scale={[1, 0.98, 0.98]}
                      >
                        <mesh
                          name="Box006_15_-_Default_0"
                          castShadow
                          receiveShadow
                          geometry={nodes["Box006_15_-_Default_0"].geometry}
                          material={materials["15_-_Default"]}
                        />
                      </group>
                    </group>
                    <mesh
                      name="Tube001_01_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Tube001_01_-_Default_0"].geometry}
                      material={materials["01_-_Default"]}
                    />
                    <mesh
                      name="Tube001_02_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Tube001_02_-_Default_0"].geometry}
                      material={materials["02_-_Default"]}
                    />
                    <mesh
                      name="Tube001_08_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Tube001_08_-_Default_0"].geometry}
                      material={materials["08_-_Default"]}
                    />
                    <mesh
                      name="Tube001_09_-_Default_0"
                      castShadow
                      receiveShadow
                      geometry={nodes["Tube001_09_-_Default_0"].geometry}
                      material={materials["09_-_Default"]}
                    />
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}

export default Mailbox;

useGLTF.preload("/models/mailbox2.glb");
